import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  email: "",
  username: "",
  role: null,
  isLogged: false,
  userId:null,
  regions:[],
  categories: [],
  managerEmail: null,
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.email = action.payload.email;
      state.username = action.payload.username;
      state.role = action.payload.role;
      state.isLogged = action.payload.isLogged;
      state.userId = action.payload.userId;
        state.regions = action.payload.regions || []; // Optional region field
        state.categories = action.payload.categories || []; // Optional categories field
      state.managerEmail= action.payload.managerEmail || null; // Optional manager email field

    },
    removeUser: (state) => {
      state.email = "";
      state.username = "";
      state.role = null;
      state.isLogged = false;
      state.userId = null;
        state.regions = [];
        state.categories = [];
        state.managerEmail = null; // Reset manager email field

    },
  },
});

export const { setUser, removeUser } = userSlice.actions;
export default userSlice.reducer;
